import React from "react";
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';

import ProjectScope from "./projectScope";
import StonesStore from './../../stores/stonesStore';
import LazyLoad from 'react-lazyload';
import Config from './../../config';
import Analytics from './../../analytics';

export default class ProjectScopeStones extends React.Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      allStones: [],
      selectedStone: null
    };
  }

  componentDidMount(){

    let allStones = [],
        timerId,
        that = this;

    const href = window.location.href;
    const local = /gfd.us/.test(href); // Eugen's local
    const thisRunStones = local || Config.kvConfig.disableStonesScrolling ? () => {} : this.runStones;

    function timeout() {
      allStones = _.slice(_.shuffle(StonesStore.supportedStones()),0,100);  // take 100 random stones

      if (allStones.length) {
        that.setState({
          allStones
        }, () => {
          thisRunStones()
        });
        clearTimeout(timerId);

      } else {
        timerId = setTimeout(timeout, 50);
      }

    }

    timeout();  // run interval checking until stones are loaded

    document.setStoneFromIframe = (data) => {
      let stone = StonesStore.stoneById(data.quote.stone.Id);

      if (stone) {
        ProjectScope.setStone(stone);
        ProjectScope.setFeaturesToDisplay(data.quote.features); // show new features in iframe, but do not change in the list

        let stones = this.state.allStones;

        if (_.findIndex(this.state.allStones, { Id: data.quote.stone.Id }) < 0) { // if not found add it
          stones.splice(50, 0, stone); // insert in the middle of array
        }

        this.setState({
          selectedStone: stone,
          allStones: stones
        }, () => {
          this.scrollToSelectedStone();
        });
      }

    };

  };

  runStones = () => {
    const quoteStone = ProjectScope.quote().stone;

    if (quoteStone) {

      let stones = this.state.allStones;

      if (_.findIndex(this.state.allStones, { Id: quoteStone.Id }) < 0) { // if not found add it
        stones.splice(50, 0, quoteStone); // insert in the middle of array
      }

      this.setState({
        allStones: stones,
        selectedStone: quoteStone,
      }, () => {
        this.scrollToSelectedStone();
      })
    } else {
      $( ".project-scope-stones-list-inner" ).draggable({
        axis: "x"
      });

      //if (!Config.isInterentExplorer()) {
        function animateStones() {
          $('.project-scope-stones-list').css('left','0').animate({left: "-100%"}, 80000, "linear", animateStones);
        }
        animateStones();
      //}
    }
  };

  scrollToSelectedStone = () => {
    const animated = $('.project-scope-stones-list'),
      inner    = animated.find('.project-scope-stones-list-inner'),
      left     = animated.find('.project-scope-stones-list-item--selected').position().left;

    animated.css('left','0').stop();
    inner.animate({left: -left + 800}, 1000, "linear");

    inner.draggable({
      axis: "x"
    });
  };

  handleStoneClick = (stone) => {

    // console.log('stone selected:', stone);

    Analytics.sendClickEvent('stone');
    ProjectScope.setStone(stone);

    const animated = $('.project-scope-stones-list'),
          left     = animated.css('left'),
          mobBtn   = $('.project-scope-mobile-stones-link');

    mobBtn && mobBtn.addClass('project-scope-mobile-stones-link--active');
    animated.css('left', left).stop(); //workaround fixing animated stopping position

    this.setState({
      selectedStone: stone
    });

  };

  render() {

    const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      centerMode: false,
      autoplay: true,
      easing: 'linear',
      autoplaySpeed: 100,
      afterChange: () => {}
    };

    return (
      <div className="project-scope-stones-list">
        <div className="project-scope-stones-list-inner">
          {
            this.state.allStones.length ? (
              this.state.allStones.map(stone => {
                const key = stone.Id + "_" + this.state.allStones.indexOf(stone);
                const style = {
                  backgroundImage:"url('" + stone.ImageUrl + "')"
                };
                const stoneItem = (
                  <div className={"project-scope-stones-list-item clickable "
                  +((this.state.selectedStone && (this.state.selectedStone.Id === stone.Id)) ? "project-scope-stones-list-item--selected" : "")}
                       style={style} key={key} onClick={(e) => { this.handleStoneClick(stone) }}/>
                );

                if(this.state.isMobile) {
                  return (
                    <LazyLoad height={225} offset={450} unmountIfInvisible={true} placeholder={<div className="step2Placeholder"/>} key={key}>
                      {stoneItem}
                    </LazyLoad>
                  );
                } else if(Config.kioskStandAlone) {
                  return (
                    <LazyLoad height={225} offset={2250} unmountIfInvisible={true} placeholder={<div className="step2Placeholder"/>} key={key}>
                      {stoneItem}
                    </LazyLoad>
                  );
                }
                return stoneItem;
              })
            ) : null
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projectScope/projectScopeStones.js